import { HeadCell } from 'components/ui/EnhancedTable';
import useAxios from 'library/axios'; 
import { useState } from 'react';
import {IJob,  IJobSearch } from "../models/Job";
import { useTranslation  } from 'react-i18next';
import { ITextFilterElement } from 'components/ui/BasicTextFilterForm';

import { IResult } from 'library/interface';

import { useNavigate } from 'react-router-dom';


const _ = () => {

    const axios = useAxios();     

    const createJob = async (job: IJob)  =>       
        await (await axios.post('/api/misc/job/create', job)).data;       
        
    const updateJob = async (job: IJob)  =>       
        await (await axios.post('/api/misc/job/update', job)).data; 
    
    const getJob = async (id  : number )  => {
      const {data} = (await axios.get(`/api/misc/job/get-job/${id}`));
      return await data;
    }

    const getJobs = async (criteria: IJobSearch) : Promise<IJob[]> => {
      const {name, description} = criteria;

      const {data} = (await axios.get(`/api/misc/job/get-jobs?name=${name}&description=${description}`));
      return await data;
    }

    const getJobScheduleQueryExecuteExport = async (jobScheduleId: number): Promise<IResult<any>>  => {
      const {data} = (await axios.get(`/api/misc/job/get-jobSchedule-queryExcecute-export?jobScheduleId=${jobScheduleId}`));
      return await data;
    }
      
    return {    
      createJob,
      updateJob,

      getJob,
      getJobs,

      getJobScheduleQueryExecuteExport
      
    } 
}

export default _;


export const useBasicFilterJob = ( onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IJob) => void  ) => {

  const { getJobs } = _();

  const { t, i18n } = useTranslation();   
  const navigate = useNavigate();
  

  const [headJobCells, setHeadJobCells]  = useState<HeadCell<IJob>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', width: 10 },
    {id:'name', label : t('Name'),  display: true, type: 'string',width: 40 },
    {id:'description', label : t('Description'),  display: true, type: 'string',width: 40 },
    {id:'isActive', label : t('Active ?'),  display: true, type: 'boolean', width: 10},
  ]); 

  const [filterElements, ] = useState([       
        {name: 'name', text: t('Name'), value: ''}, 
        {name: 'description', text: t('Description'), value: ''},       
      ]);

  const [filteredReports, ] = useState<IJob[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[]): Promise<IJob[]> => {
            
    const name = filterElements.find( elt => elt.name === 'name')?.value || '';
    const description = filterElements.find( elt => elt.name === 'description')?.value || '';
    
    const arr = await getJobs( {name, description} );
    
    return arr;
  }

  const objKey: keyof IJob = 'id';

  return {
    title: t('Request data'), headCells: headJobCells, objKey,
    filterElements, rows: filteredReports, 
    onFilterButtonClick, onRowDoubleClick
  }
}

